import { defineStore } from 'pinia'
import { getAuthInfo } from '@/api/auth'

function normalizeTree(list) {
  return (list || []).map(item => ({
    ...item,
    children: normalizeTree(item.children || [])
  }))
}

const tenantManagePathSet = new Set(['/system/user', '/system/role', '/system/role-perm'])

function normalizePath(path) {
  if (!path) return ''
  return path.startsWith('/') ? path : `/${path}`
}

function filterMenusByUserLevel(list, level) {
  if (level <= 1) {
    return list
  }
  return (list || [])
    .filter(item => !tenantManagePathSet.has(normalizePath(item.path)))
    .map(item => ({
      ...item,
      children: filterMenusByUserLevel(item.children || [], level)
    }))
}

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    user: {},
    menuTree: [],
    perms: [],
    loaded: false
  }),
  actions: {
    async loadAuthInfo(force = false) {
      if (this.loaded && !force) {
        return
      }
      const data = await getAuthInfo()
      this.user = data.user || {}
      const level = Number(this.user.level || 0)
      const menuTree = normalizeTree(data.menus || [])
      this.menuTree = filterMenusByUserLevel(menuTree, level)
      this.perms = data.perms || []
      this.loaded = true
      localStorage.setItem('userInfo', JSON.stringify(this.user))
    },
    reset() {
      this.user = {}
      this.menuTree = []
      this.perms = []
      this.loaded = false
    }
  }
})
